import { ContentWrapper } from "@/components/layout/content";
import headshotJpg from "@/public/images/homepage/about/headshot.jpg";
import headshotWebp from "@/public/images/homepage/about/headshot.webp";
import { GlitchText } from "@/components/ui/GlitchText";

export function AboutSection() {
  return (
    <section className="py-24 bg-transparent overflow-hidden" id="about">
      <ContentWrapper>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20 items-center">
          {/* Visual: Image Area */}
          <div className="relative order-2 lg:order-1 lg:col-span-2">
            <div className="absolute inset-0 bg-emerald-500/10 translate-x-4 translate-y-4 rounded-sm border border-emerald-500/20"></div>
            <div className="bg-gray-900 border border-gray-800 aspect-3/4 md:aspect-square lg:aspect-4/5 rounded-sm relative z-10 overflow-hidden shadow-2xl">
              <picture className="w-full h-full block">
                <source srcSet={headshotWebp} type="image/webp" />
                <img
                  src={headshotJpg}
                  alt="Johann Lochbaum"
                  className="w-full h-full object-cover"
                />
              </picture>
            </div>
          </div>

          {/* Content: Plug & Play Manifest */}
          <div className="order-1 lg:order-2 lg:col-span-3">
            <div className="space-y-8 text-gray-300 font-sans leading-relaxed">
              <div className="">
                <h3 className="text-gray-50 text-lg md:text-3xl font-bold">
                  <GlitchText text="Über mich" glitchClassName="text-emerald-400" />
                </h3>
                <span className="font-mono">Johann Lochbaum</span>
              </div>

              <div className="text-gray-400 text-base md:text-lg space-y-3">
                <p>
                  Für mich ist Softwareentwicklung kein stures Abarbeiten von Tickets, sondern die
                  Kunst, sich immer wieder neu zu erfinden. Anpassungsfähigkeit steht bei meiner
                  Arbeit an oberster Stelle: Ich passe mich nicht nur neuen Tech-Stacks blitzschnell
                  an, sondern wachse an jeder neuen Herausforderung und jedem komplexen Problem.
                </p>
                <p>
                  Mein Fokus liegt ohne Kompromisse auf der Qualität der Lösungen. Ich baue keine
                  schnellen Übergangslösungen, sondern durchdachte, nachhaltige Systeme, die
                  technisch sauber sind und das Projekt langfristig nach vorne bringen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </ContentWrapper>
    </section>
  );
}
